import { Phone, Instagram, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACTS } from "../lib/data";

const WhatsAppIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.05h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43l-.48-.01c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29Z" />
  </svg>
);

const CtaBlock = ({ contact, testid }) => (
  <div className="group border border-[var(--cx-border)] bg-[var(--cx-surface)] p-8 md:p-10 transition-colors duration-500 hover:border-[var(--cx-gold)]/50">
    <p className="overline">{contact.role}</p>
    <h3 className="mt-3 font-display text-3xl md:text-4xl font-light text-[var(--cx-white)]">{contact.name}</h3>
    <div className="mt-8 flex flex-col gap-3">
      <a
        href={`https://wa.me/${contact.intl}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`whatsapp-${testid}`}
        className="flex items-center justify-between border border-[var(--cx-border)] px-6 py-4 font-body text-sm tracking-wide text-[var(--cx-white)] transition-all duration-300 hover:bg-[var(--cx-gold)] hover:text-black"
      >
        <span className="flex items-center gap-3"><WhatsAppIcon /> WhatsApp</span>
        <span className="opacity-60">{contact.phone}</span>
      </a>
      <a
        href={`tel:+${contact.intl}`}
        data-testid={`phone-${testid}`}
        className="flex items-center justify-between border border-[var(--cx-border)] px-6 py-4 font-body text-sm tracking-wide text-[var(--cx-white)] transition-all duration-300 hover:bg-[var(--cx-gold)] hover:text-black"
      >
        <span className="flex items-center gap-3"><Phone size={22} /> Chiama ora</span>
        <span className="opacity-60">{contact.phone}</span>
      </a>
    </div>
  </div>
);

export const Contatti = () => (
  <section id="contatti" data-testid="contatti-section" className="relative py-24 md:py-36">
    <div className="cx-container">
      <Reveal>
        <p className="overline">Contatti</p>
        <h2 className="mt-4 max-w-4xl font-display text-4xl md:text-6xl font-light leading-none text-[var(--cx-white)]">
          Raccontaci il tuo <span className="gold-text italic">obiettivo</span>.
          <br />Al resto pensiamo noi.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-2">
        <Reveal delay={0.05}><CtaBlock contact={CONTACTS.home} testid="home" /></Reveal>
        <Reveal delay={0.15}><CtaBlock contact={CONTACTS.auto} testid="auto" /></Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-6 flex flex-col gap-4 sm:flex-row">
          <a
            href={CONTACTS.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-link"
            className="flex flex-1 items-center justify-center gap-3 border border-[var(--cx-border)] px-6 py-5 font-body text-sm tracking-wide text-[var(--cx-white)] transition-all duration-300 hover:bg-[var(--cx-gold)] hover:text-black"
          >
            <Instagram size={22} /> @{CONTACTS.instagram}
          </a>
          <a
            href={`mailto:${CONTACTS.email}`}
            data-testid="email-link"
            className="flex flex-1 items-center justify-center gap-3 border border-[var(--cx-border)] px-6 py-5 font-body text-sm tracking-wide text-[var(--cx-white)] transition-all duration-300 hover:bg-[var(--cx-gold)] hover:text-black"
          >
            <Mail size={22} /> {CONTACTS.email}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
